/**
 * 判断是否为 hho 日常环境
 */
export const isDaily = (): boolean => {
  return window.location.href.indexOf("https://daily-") === 0;
};

/**
 * 判断是否为 hho 线上环境
 */
export const isProd = (): boolean => {
  return window.location.href.indexOf("https://link.7sgood.com") === 0;
};

/**
 * 判断是否为dev
 */
export const isDev = (): boolean => {
  return process.env.NODE_ENV === "development";
};
